import { Toolbar } from "@material-ui/core";
import {  Create, Datagrid, Edit, EditButton, FunctionField, List, ReferenceField, ReferenceInput, NumberInput, required, SelectInput, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput, ArrayInput, SimpleFormIterator, ArrayField,useRecordContext, DateInput, DateField, TabbedForm, FormTab, SaveButton} from "react-admin";
import { Link } from "react-router-dom";
// import { DownloadReport } from "../components/remuneration-report-download";

// const DownloadButton = ({ record }) => (
//     <Button
//         component={Link}
//         to={{
//             pathname: '/#/download-report/' + record.id,
//         }}
//         label="Download"
//     >
//         Download
//     </Button>
// );

const reportMonthFilters = [
    <TextInput source="month_raw" alwaysOn />,
    <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" optionValue="id"/></ReferenceInput>
];

export const ReportMonthList = () => (
    <List filters={reportMonthFilters}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="currency" />
            <TextField source="status" />
            <TextField source="month_raw" />
            {/* <UrlField source="report_url" /> */}
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            {/* <NumberField source="total_working_days" /> */}
            <ShowButton label="View" />
            <EditButton label="Edit" />
        </Datagrid>
    </List>
);

// const ShowActions = ({ basePath, data, resource }) => (
//     <TopToolbar>
//         {/* Add your custom actions */}
//         {/* <div>{data}</div> */}
//         <DownloadButton />
//         <EditButton />
//     </TopToolbar>
// );

export const ReportMonthShow = (props) => (
    <Show >
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="currency" />
            <TextField source="status" />
            <TextField source="month_raw" />
            {/* <UrlField source="report_url" /> */}
            <FunctionField label="Name" render={record => { 
                const url = "/report-download/remuneration/" + record.id + "/"+record.name;
                return (<div><Link target="_blank" to={url}>Download</Link></div>);
                }} />
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <TextField source="bill_no" />
            <ArrayField source="invoice_labels" label="Invoice Labels">
                <Datagrid>
                <ReferenceField source="company_id" reference="companies"><TextField source="full_name" /></ReferenceField>
                <TextField source= "invoice_no" label="Invoice No"/>
                <DateField source="invoice_date" label="Invoice Date" locales='en-IN' /> 
                </Datagrid>
            </ArrayField>

        </SimpleShowLayout>
    </Show>
);

export const ReportMonthCreate = () => (
    <Create>
        <SimpleForm>
            <p>
                <b>Points To Note Before creating remuneration report</b><br />
                <br />1. Check if calendar data is added of the month for which the report is generated.
                <br />2. Check if all the employees who are joined for the month is added in software and relieved employees made inactive and updated their relieving dates.
            </p>
            <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            <SelectInput source="currency" choices={[
                { id: 'INR', name: 'INR' },
                { id: 'USD', name: 'USD' },
                { id: 'JPY', name: 'JPY' },
            ]} validate={required()} />
            <TextInput source="month_raw" validate={required()} />
            <TextInput source="bill_no" label="Bill Number" />
            <ArrayInput source="invoice_labels" label="Invoice Labels">
                <SimpleFormIterator>
                <ReferenceInput source="company_id" reference="companies"><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>
                <TextInput source= "invoice_no" label="Invoice No"/>
                <DateInput source="invoice_date" label="Invoice Date" />
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);

// export const ReportMonthEdits = () => {
//     <Edit>
//         <SimpleForm>
//             <SelectInput source="action" label="Action" choices={[
//                 { id: 'refresh', name: 'Refresh Data' },
//                 { id: 'attendance', name: 'Refetch Attendance' },
//                 { id: 'escalation', name: 'Calculate Escalattion' },
//             ]} />
//             <TextInput source="name" />
//             <SelectInput source="status" choices={[
//                 { id: 'draft', name: 'Draft' },
//                 { id: 'final', name: 'Final' },
//             ]} />
//             <NumberInput onWheel={e => e.target.blur()} source="intl_experta_total_value" label="International Key Expert Total Contract Value" fullWidth/>
//             <NumberInput onWheel={e => e.target.blur()} source="intl_expertb_total_value" label="International Non Key Expert Total Contract Value" fullWidth/>
//             <NumberInput onWheel={e => e.target.blur()} source="ntl_expert_total_value" label="National Key Expert Total Contract Value" fullWidth/>
//             <NumberInput onWheel={e => e.target.blur()} source="ntl_expertb_total_value" label="National Non Key Expert Total Contract Value" fullWidth/>
//             <NumberInput onWheel={e => e.target.blur()} source="support_total_value" label="Supporting Stafff Total Contract Value" fullWidth/>
//             {/* <ArrayInput source="invoice_labels" label="Invoice Labels">
//                 <SimpleFormIterator>
//                 <ReferenceInput source="company_id" reference="companies"><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>
//                 <TextInput source= "invoice_no" label="Invoice No"/>
//                 </SimpleFormIterator>
//             </ArrayInput> */}
//             <InvoiceData />
//         </SimpleForm>
//     </Edit>
// };

const InvoiceData = () => {
    const report = useRecordContext();
    return <><TextInput source="bill_no" label="Bill Number" />
    <ArrayInput source="invoice_labels" label="Invoice Labels">
    <SimpleFormIterator>
    <ReferenceInput source="company_id" reference="companies" filter={{parent_company_id:report.parent_company_id}}><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>
    <TextInput source= "invoice_no" label="Invoice No"/>
    <DateInput source="invoice_date" label="Invoice Date" />
    </SimpleFormIterator>
    </ArrayInput></>
}

export const Report_monthEdit = () => (
    <Edit>
            <TabbedForm>
                <FormTab label="Options">
                <TextField source="name" />
                <SelectInput source="action" label="Action" choices={[
                        { id: 'refresh', name: 'Refresh Data' },
                        { id: 'attendance', name: 'Refetch Attendance' },
                        { id: 'escalation', name: 'Calculate Escalation' },
                    ]} />
                <SelectInput source="status" choices={[
                        { id: 'draft', name: 'Draft' },
                        { id: 'final', name: 'Final' },
                    ]} />
                </FormTab>
                <FormTab label="Original Contract Value">
                    <NumberInput onWheel={e => e.target.blur()} source="intl_experta_total_value" label="International Key Expert Total Contract Value" fullWidth/>
                    <NumberInput onWheel={e => e.target.blur()} source="intl_expertb_total_value" label="International Non Key Expert Total Contract Value" fullWidth/>
                    <NumberInput onWheel={e => e.target.blur()} source="ntl_expert_total_value" label="National Key Expert Total Contract Value" fullWidth/>
                    <NumberInput onWheel={e => e.target.blur()} source="ntl_expertb_total_value" label="National Non Key Expert Total Contract Value" fullWidth/>
                    <NumberInput onWheel={e => e.target.blur()} source="support_total_value" label="Supporting Stafff Total Contract Value" fullWidth/>
                </FormTab>
                <FormTab label="GC Billing Details">
                    <InvoiceData />
                </FormTab>
                <FormTab label="Calculate Escalation For Period">
                <NumberInput source='month_limit' defaultValue={5} min={0} max={12} onWheel={e => e.target.blur()}/>
                </FormTab>
            </TabbedForm>
    </Edit>
);


export const Report_monthEditCAdmin = () => (
    <Edit>
        <TabbedForm toolbar={<Toolbar><SaveButton /></Toolbar>}>
            <FormTab label="GC Billing Details">
                <InvoiceData />
            </FormTab>
            <FormTab label="Options">
                <br />Status :<TextField source="status" />
                <SelectInput source="action" label="Action" choices={[
                    { id: 'refresh', name: 'Refresh Data' },
                    { id: 'escalation', name: 'Calculate Escalation' }
                ]} />
            </ FormTab>
            <FormTab label="Calculate Escalation For Period">
                <NumberInput source='month_limit' defaultValue={5} min={0} max={12} onWheel={e => e.target.blur()} />
            </FormTab>
        </TabbedForm>
    </Edit>
);
